import { render, staticRenderFns } from "./SentSummaryContainer.vue?vue&type=template&id=9cd852ac&scoped=true&"
import script from "./SentSummaryContainer.vue?vue&type=script&lang=js&"
export * from "./SentSummaryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd852ac",
  null
  
)

export default component.exports